import { FormComponentModel } from './form-component-model';
import { Injector } from '@angular/core';
import { ObjectType } from './../../product/shared/models/Enums.enum';
import { BaseComponent } from '../../shared/base/base-component/base-component.component';
import { FormGroup } from '@angular/forms';
import { PageHeaderComponentModel } from '../interfaces/page-header-component-model';
import { environment } from 'src/environments/environment';
import { ChangeLogTemplateComponent } from '../templates/change-log-template/change-log-template.component';
import { AttributeValue } from '../interfaces/Attribute';
import { AppConfigService } from '../services/app-config.service';

export abstract class EditComponentModel extends BaseComponent {
  formGroup: FormGroup;
  recordId: number;
  record: any;
  componentModel: PageHeaderComponentModel;
  layoutModelsLoaded = false;
  submitting = false;
  model = '';
  mode = 'edit';
  selectedLanguage = 0;
  empededMode = false;
  defaultLanguageId = 0;
  constructor(injector: Injector) {
    super(injector);
    this.layoutModelsLoaded = false;
    this.formGroup = this.fb.group({});

    const route$ = this.route.params.subscribe((d) => {
      const parentParams = this.route.snapshot.parent?.params;
      this.model = d['model'];
      this.empededMode = false;
      if (this.model == null && parentParams != null) {
        this.model = parentParams['model'];
        this.empededMode = true;
      }
      this.formGroup = this.fb.group(
        FormComponentModel.getControls(this.model, this.mode)
      );
      this.layoutService.getPageHeaderComponent(
        this.model,
        'edit',
        (d: PageHeaderComponentModel) => {
          this.componentModel = d;

          this.route.params.subscribe((d: any) => {
            this.recordId = Number(d.id);
            this.getRecordDetails();
          });
        }
      );
      if (d['mode'] != null && d['mode'] === 'reader') {
        this.formGroup.disable();
      }
    });
    this.subscriptions.push(route$);

    this.subscriptions.push(
      this.commonService.defaultLanguage.subscribe((lang) => {
        this.defaultLanguageId = +lang.Code;
      })
    );
  }

  languageChanged(newSelectedLanguage: number) {
    this.selectedLanguage = newSelectedLanguage;
    // this.getRecordDetails();
  }

  override submit(record?: any): void {
    this.submitting = true;
    const newRecord = this.beforeSubmit();
    if (newRecord != null) {
      record = newRecord;
    }
    if (this.formGroup.valid) {
      if (
        this.selectedLanguage === 0 ||
        this.selectedLanguage === this.defaultLanguageId
      ) {
        this.normalSubmit(record);
      } else {
      
        this.submitTranslation();
      }
    } else {
      Object.values(this.formGroup.controls).forEach((control) => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });

      this.submitting = false;
    }
  }

  viewHistory(type: ObjectType): void {
    const drawerRef = this.drawerService.create<ChangeLogTemplateComponent>({
      nzTitle: 'test',
      nzWrapClassName: 'drawer-size-4x drawer-body-no-padding',
      nzContent: ChangeLogTemplateComponent,
      nzContentParams: {
        objectId: this.recordId,
        objectType: type,
      },
    });
  }
  normalSubmit(record: any) {
    const dirtyValues = record ?? this.getDirtyValues();

    if (
      !Array.isArray(dirtyValues['AttributeValues']) &&
      dirtyValues['AttributeValues'] != null
    ) {
      const attributes = Object.keys(dirtyValues['AttributeValues'] as any);
      const avs = dirtyValues['AttributeValues'];
      
      dirtyValues['AttributeValues'] = [];
      dirtyValues['ObjectType'] = this.componentModel.objectType;
      attributes.forEach((attribute) => {
        const attributeType = attribute.split('.')[0];
        const attributeId = attribute.split('.')[1];

        dirtyValues['AttributeValues'].push({
          AttributeId: Number(attributeId),
          ObjectId: this.recordId,
          ObjectType: this.componentModel.objectType,
          LanguageId: this.selectedLanguage,
          Value: avs[attribute]?.toString(),
          OptionValueId: attributeType === '6' ? Number(avs[attribute]) : null,
        });
      });
    }

    let endPoint = `${AppConfigService.settings.baseUrl}data-api/${encodeURI(
      this.componentModel.endPoint
    )}`;

    if (this.componentModel.customEditEndPoint != null && this.componentModel.customEditEndPoint === undefined && this.componentModel.customEditEndPoint !== '') {
      endPoint = `${AppConfigService.settings.baseUrl}${encodeURI(
        this.componentModel.customEditEndPoint
      )}`;
    }

    const _dirtyValues = this.cleanRecord(dirtyValues);

    this.connectionService.put(
      //`${AppConfigService.settings.baseUrl}data-api/${this.componentModel.endPoint}`,
      endPoint,
      this.recordId,
      dirtyValues as any,
      (record) => {
        this.afterSubmit(record);
        const message = this.getEditSuccessfullyMessage(record);
        this.message.success(message);
        this.getRecordDetails();
        this.mediaService.submitMedia$.emit();
      }
    );
    setTimeout(() => {
      this.submitting = false;
    }, 1500);
  }
  getDirtyValues() {
    let dirtyValues: { [name: string]: any } = {};

    Object.keys(this.formGroup.controls).forEach((key) => {
      let currentControl = this.formGroup.controls[key];

      //if (currentControl.dirty) {
      dirtyValues[key] = currentControl.value;
      //}
    });

    return dirtyValues;
  }

  getRecordDetails() {
    const regex = new RegExp('_SELECTED_LANGUAGE_', 'g');
    this.connectionService.details(
      `${AppConfigService.settings.baseUrl}data-api/${this.componentModel.endPoint}`,
      this.recordId,
      (record: any) => {
        this.record = record;
        if (
          this.record.AttributeValues != null &&
          this.record.AttributeValues.length !== 0
        ) {
          const avs = (this.record.AttributeValues as AttributeValue[]).filter(
            (x) => x.LanguageId == this.selectedLanguage
          );
          this.record.AttributeValues = {};
          avs.forEach((av: any) => {
            this.record.AttributeValues[`${av.AttributeId}`] = av.Value;
          });
        }

        this.formGroup.patchValue(record);
        this.recordDetailsLoaded();
        this.layoutModelsLoaded = true;
      },
      this.componentModel.detailsExpandExpression?.replace(
        regex,
        this.selectedLanguage.toString()
      )
    );
  }
  abstract getEditSuccessfullyMessage(record: any): string;
  abstract recordDetailsLoaded(): void;
  abstract beforeSubmit(): any | void;
  abstract afterSubmit(record: any): void;
  abstract cleanRecord(record: any): any;
  abstract submitTranslation(): void;
}
